import React, { useEffect } from 'react';
import { useLatest } from 'ahooks';
import useChart from '@intelligence/v3/_hooks/chart/useChart';
import { LANGUAGE_EN } from '@home/_config/config';
import { getLineChartDynamicOption } from './utils';
import { LINE_CHART_STATIC_OPTION } from './constants';

/**
 * 折线图组件
 */
const LineChart: React.FC<ILineChartProps> = (props) => {
  const {
    locale = LANGUAGE_EN,
    loading = true,
    data,
    useXAxisLabelRotate = false,
    enableXAxisHighLight = true,
    legendAlign = 'center',
    gridLineStyle,
    tooltipFormatter,
    yAxisLabelFormatter,
    xAxisLabelFormatter,
    legendFormatter,
    getSortedDates,
    getSortedSeries,
    updateDeps,
  } = props;

  const tooltipFormatterLatest = useLatest(tooltipFormatter);
  const yAxisLabelFormatterLatest = useLatest(yAxisLabelFormatter);
  const xAxisLabelFormatterLatest = useLatest(xAxisLabelFormatter);
  const legendFormatterLatest = useLatest(legendFormatter);
  const getSortedDatesLatest = useLatest(getSortedDates);
  const getSortedSeriesLatest = useLatest(getSortedSeries);

  const { chartNode, chartInstance, option, setOption } = useChart({
    locale: locale as string,
    initialOption: LINE_CHART_STATIC_OPTION,
  });

  const updateLineChartOption = (chartData?: ILineChartData[] | null) => {
    if (!chartInstance.current || chartInstance.current.isDisposed()) return;

    const dynamicOption = getLineChartDynamicOption(chartData, {
      useXAxisLabelRotate,
      enableXAxisHighLight,
      legendAlign,
      gridLineStyle,
      tooltipFormatter: tooltipFormatterLatest.current,
      yAxisLabelFormatter: yAxisLabelFormatterLatest.current,
      xAxisLabelFormatter: xAxisLabelFormatterLatest.current,
      legendFormatter: legendFormatterLatest.current,
      getSortedDates: getSortedDatesLatest.current,
      getSortedSeries: getSortedSeriesLatest.current,
    });

    const newOption = {
      ...option,
      ...dynamicOption,
      tooltip: {
        ...option?.tooltip,
        ...dynamicOption?.tooltip,
      },
      legend: {
        ...option?.legend,
        ...dynamicOption?.legend,
      },
      xAxis: [
        {
          // @ts-ignore
          ...option?.xAxis?.[0],
          ...dynamicOption?.xAxis?.[0],
        },
      ],
      yAxis: [
        {
          // @ts-ignore
          ...option?.yAxis?.[0],
          ...dynamicOption?.yAxis?.[0],
        },
      ],
    } as any;

    setOption(newOption);
  };

  useEffect(() => {
    if (loading) return;
    updateLineChartOption(data);
  }, [locale, loading, data, updateDeps]);

  return (
    <div className="dbi-chart-con">
      <div className="dbi-chart-con__wrapper dbi-chart-line">
        <div className="dbi-chart-con__inner dbi-chart-line-main" ref={chartNode}></div>
      </div>
    </div>
  );
};

export default LineChart;
